import styled from "styled-components";

export const Error = styled.div`
  color: ${p => p.theme.error};
  margin-bottom: 5px;
  font-size: 13px;
  font-weight: 200;
  &:first-letter {
    text-transform: capitalize;
  }
`;
